export class YearsTradingDataList {
    private yearsTradingList: string[] = ['1', '2', '3', '4', '5-9', '>10'];
    public getYearsTradingList(): Array<string> {
        return this.yearsTradingList;
    }
}
